<div>
  <app-notificaciones-lista></app-notificaciones-lista>
</div>
